import React from 'react';
import { PageStyle } from '../Utils/generalStyles';

// Components
import AccountInfoSection from '../Components/Profile/accountInfo';
import FooterSection from '../Components/Footer';

const ProfilePage = () => (
  <PageStyle>
    <AccountInfoSection />
    <FooterSection />
  </PageStyle>
);

export default ProfilePage;
